<template>
  <div>
<div id="info1" style="padding: 10px">
    <p style="line-height:18px; margin:0px; text-align:justify; text-indent:390px"><a name="OLE_LINK5"></a></p>
    <p style="line-height:18px; font-size:14px; margin:0px; text-align:justify">
        《用户授权协议》(以下简称<span style="font-weight: bold">“本协议”</span>)是中储智运科技股份有限公司
        （以下简称<span style="font-weight: bold">“中储智运”</span>或<span style="font-weight: bold">“我们”</span>）与用户（以下简称<span style="font-weight: bold">“您”</span>）
        所订立的有效合约。
        <span style="font-weight: bold">请您先仔细阅读本协议内容，尤其是加粗的字体部分。如您对本协议内容或页面提示信息有任何疑问，请勿进行下一步操作。
            如您对协议有任何疑问，可向平台客服咨询，平台客服热线：<a style="font-family:宋体; font-size:14px;color:#5086FC" href="javascript:void(0);" onclick="callService()">400-088-5566</a>。如您通过页面点击同意或我们认可的其他方式确认本协议即表示您已同意本协议。
        </span>
    </p>

    <p style="line-height:18px; font-size:14px; margin:0px; text-align:justify;margin-top: 15px">
        <span style="font-weight: bold">1、为了便于您使用第三方的服务，您同意中储智运平台将您的用户信息及页面提示的相关信息传递给第三方。页面提示上会展示具体授权对象以及授权信息类型，您的信息将通过加密通道传递给第三方。</span>
        中储智运会要求第三方严格遵守相关法律法规与监管要求，依法使用您的信息，并应对您的信息保密。点击授权之后，授权关系长期有效，直至您主动解除。
    </p>
    <p style="line-height:18px; font-size:14px; margin:0px; text-align:justify;margin-top: 15px">
        <span style="font-weight: bold">
            2、上述第三方服务由该第三方独立运营并独立承担全部责任。因第三方服务或其使用您的信息而产生的纠纷，或第三方服务违反相关法律法规或协议约定，或您在使用第三方服务过程中遭受损失的，请您和第三方协商解决。
        </span>
    </p>
    <p style="line-height:18px; font-size:14px; margin:0px; text-align:justify;margin-top: 15px">
        <span style="font-weight: bold">
            3、如我们对本协议进行变更，我们将通过公告或客户端消息等方式予以通知，该等变更自通知载明的生效时间开始生效。若您无法同意变更修改后的协议内容，您有权停止使用相关服务；双方协商一致的，也可另行变更相关服务和对应协议内容。
        </span>
    </p>
    <p style="line-height:18px; font-size:14px; margin:0px; text-align:justify;margin-top: 15px">
        <span style="font-weight: bold">
            4、您同意本协议中的授权不可撤回或者撤销。
        </span>
    </p>
    <p style="line-height:18px; font-size:14px; margin:0px; text-align:justify;margin-top: 15px">
        5、本协议未约定事宜，均以中储智运平台网站公布的
        <a style="font-family:宋体; font-size:14px;color:#5086FC" @click="showAgreement('serveAgreement')">《中储智运平台服务协议》
        </a>
        及相关规则为补充；本协议与《中储智运平台服务协议》及相关规则不一致的地方，以本协议为准。
    </p>
    <p style="line-height:18px; font-size:14px; margin:0px; text-align:justify;margin-top: 15px">
        6、本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。因本协议产生的争议，均应依照中华人民共和国法律予以处理，您同意由南京市鼓楼区人民法院管辖。
    </p>
</div>
        <el-dialog
            :append-to-body="true"
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            width="1100px">
            <div style="height:500px;padding:20px; word-break:break-all; overflow-y:auto">
                <component :is="activeAgreement"></component>
            </div>
        </el-dialog>
  </div>
</template>
<script>
import serveAgreement from './serveAgreement.vue'
Vue.component('serveAgreement', serveAgreement);
import dealAgreement from './dealAgreement.vue'
Vue.component('dealAgreement', dealAgreement);
import permissonAgreement from './permissonAgreement.vue'
Vue.component('permissonAgreement', permissonAgreement);
import privacyAgreement from './privacyAgreement.vue'
Vue.component('privacyAgreement', privacyAgreement);
export default {
    data(){
        return {
            dialogTitle:'',
            dialogVisible:false,
            activeAgreement:''
        }
    },
    methods:{
        showAgreement(acitveName){
            this.dialogVisible = true
            this.activeAgreement = acitveName
            switch(acitveName){
                case 'serveAgreement':
                    this.dialogTitle = '中储智运平台服务协议'
                break;
                case 'dealAgreement':
                    this.dialogTitle = '中储智运网络货运平台交易规则'
                break;
                case 'permissonAgreement':
                    this.dialogTitle = '用户授权协议'
                break;
                case 'privacyAgreement':
                    this.dialogTitle = '隐私政策'
                break;
            }
        },
    }
}
</script>
<style lang="stylus" scoped>
.sit_div_new{ width:998px; margin:0 auto;}
.page-desc-inner{ background: #00bbfc;box-shadow:0 0 5px rgba(0, 0, 0, 0.25) inset;opacity:0.9; height:40px; padding:5px;}
.page-desc-inner h3{ text-align:center; font-weight:400; text-shadow:0 1px 0 #666; line-height:40px; color:#fff;font-family: "微软雅黑","Microsoft Yahei",Arial,Helvetica,sans-serif,"宋体";}
.sit_div_h3{ font-size:18px; font-weight:400; line-height:60px;font-family: "微软雅黑","Microsoft Yahei",Arial,Helvetica,sans-serif,"宋体"; color:#414141;}
.p_one,.red_p,.p_one1{ line-height:25px; font-size:13px; margin:0 0 10px;}
.span_dyt,.span_dyt1,.span_dyt2{ font-size:14px; padding-right:28px; font-weight:400;font-family: "微软雅黑","Microsoft Yahei",Arial,Helvetica,sans-serif,"宋体";}
.p_one_line{ border-bottom:1px solid #d1d1d1; height:1px; margin-top:20px; margin-bottom:10px;}
.span_dyt1{ padding-right:42px;}
.span_dyt2{ padding-right:15px;}
.red_p{ color:#FF0000;}
.p_one1{ text-indent:2em;}
</style>